// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8YLmJ","colMin":"styles_colMin__2achH"};